
import React from "react";
import CourseDetailLoading from "@/components/course-detail/CourseDetailLoading";
import CourseDetailError from "@/components/course-detail/CourseDetailError";

export function SectionLoader({ isLoading, error }: { isLoading: boolean, error: unknown }) {
  if (isLoading) return <CourseDetailLoading />;
  if (error) return <CourseDetailError />;
  return null;
}
